import React, { Fragment } from 'react';
import { Column, Table, PageBar, Loading } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import useTable from '../../../leads_component/shared-components/hooks/useAsyncTable';
import useFeedback from '../../../leads_component/shared-components/hooks/useFeedback';

import FeedBackDialog from '../../common/feedback';

const MyTable = () => {
  const feedbackHooks = useFeedback();
  const tableHooks = useTable({
    deps: [],
    getList: (setTableData, setTotal, curPage, pageSize) =>
      RPCFactory.multiaccount
        .getBindHistory({
          pageIndex: curPage,
          pageSize,
        })
        .done((data) => {
          setTableData(data.entities);
          setTotal(data.size);
        })
        .fail((status, msg) => {
          feedbackHooks.showErrorTip(msg ? msg : '请求失败');
        }),
  });

  const renderID = (type, name, value, row) => {
    if (type == 'data') {
      if (row.subWeChatAppId && row.subWeChatAppId != '') {
        return row.subWeChatAppId;
      }
      return row.subAccountId;
    }
    return value;
  };

  const renderRange = (type, name, value, row) => {
    if (type == 'data') {
      const endlabel = row.endTime ? row.endTime : '至今';
      return `${row.startTime} - ${endlabel}`;
    }
    return value;
  };
  const renderEmpty = () => (
    <div className="empty">
      <span className="empty-icon"></span>
      <span className="empty-des">您还没有绑定历史</span>
    </div>
  );

  const renderTable = () => (
    <Fragment>
      <div className="datalist">
        <Table data={tableHooks.data}>
          <Column name="subAccountId" render={renderID}>
            账号ID
          </Column>
          <Column name="subAccountName">主体名称</Column>
          <Column name="time-range" render={renderRange}>
            绑定时间
          </Column>
          <Column name="applicantName">绑定请求发起人</Column>
        </Table>
      </div>
      <PageBar {...tableHooks.pageBarAttr} />
    </Fragment>
  );
  const isEmpty = !tableHooks.tableLoading && tableHooks.pageBarAttr.totalSize == 0;
  const History = (
    <div className="datarea" id="datarea">
      <div className="toolbars">
        <h4>历史记录</h4>
      </div>
      <FeedBackDialog {...feedbackHooks} />
      {tableHooks.tableLoading ? <Loading /> : renderTable()}
    </div>
  );
  return (
    <div className="onlycard">
      <div className="card">
        { isEmpty ? renderEmpty() : History }
      </div>
    </div>
  );
};

export default MyTable;
